import { TPlayabilityStatus } from '../types/playButtonTypes';

// NOTE: This does not override the true event name since it is set in:
// Roblox.CoreScripts.WebApp/Roblox.CoreScripts.WebApp/js/core/services/playGames/playGameService.js
// Roblox.GameLaunch.WebApp/Roblox.GameLaunch.WebApp/js/gamePlayEvents.js
const eventStreamProperties = (
  placeId: number
): {
  eventName: string;
  ctx: string;
  properties: { placeId: number };
  gamePlayIntentEventCtx: string;
} => ({
  eventName: 'playGameClicked',
  ctx: 'click',
  properties: {
    placeId
  },
  gamePlayIntentEventCtx: 'PlayButton'
});

const playButtonTranslationMap: Record<
  Exclude<
    TPlayabilityStatus,
    | TPlayabilityStatus.Playable
    | TPlayabilityStatus.GuestProhibited
    | TPlayabilityStatus.PurchaseRequired
  >,
  string
> = {
  [TPlayabilityStatus.UnplayableOtherReason]: 'Response.GameTemporarilyUnavailable',
  [TPlayabilityStatus.TemporarilyUnavailable]: 'Response.GameTemporarilyUnavailable',
  [TPlayabilityStatus.GameUnapproved]: 'Label.GameUnavailablePlaceUnderReview',
  [TPlayabilityStatus.IncorrectConfiguration]: 'Response.GameTemporarilyUnavailable',
  [TPlayabilityStatus.UniverseRootPlaceIsPrivate]: 'Label.GameUnavailableCurrentlyIsPrivateVisitor',
  [TPlayabilityStatus.InsufficientPermissionFriendsOnly]: 'Label.GameUnavailablePermissionLevels',
  [TPlayabilityStatus.InsufficientPermissionGroupOnly]: 'Label.GameUnavailablePermissionLevels',
  [TPlayabilityStatus.DeviceRestricted]: 'Response.GameTemporarilyUnavailable',
  [TPlayabilityStatus.UnderReview]: 'Label.GameUnavailablePlaceUnderReview',
  [TPlayabilityStatus.AccountRestricted]: 'Label.GameUnavailableAccountResrictions'
};

export default {
  playButtonTranslationMap,
  eventStreamProperties
};
